// extracted by css-extract-rspack-plugin
export default {"screen":"screen-rkq2XM","card":"card-G6DF4j","title":"title-Ewrz_j","message":"message-UokouM","stack":"stack-I2btT5","reloadButton":"reloadButton-ZeYt7i"};